import { useEffect } from 'react';

import { RunningExperiments, useExperiments } from 'state/experiments';

const TREATMENT_VARIANT = 'treatment';

/**
 * Reads the Remove Menu Favorites experiment without logging exposure.
 * Safe default: keep Favorites visible unless Amplitude resolves treatment.
 */
export const useRemoveMenuFavoritesExperiment = () => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.RemoveMenuFavorites, TREATMENT_VARIANT, {
    skipExposureLogging: true,
  });
};

export const useExposeRemoveMenuFavoritesExperiment = (shouldExpose = true) => {
  const { logExposure } = useExperiments();

  useEffect(() => {
    if (!shouldExpose) {
      return;
    }

    logExposure(RunningExperiments.RemoveMenuFavorites);
  }, [shouldExpose, logExposure]);
};
